import { render, staticRenderFns } from "./Claudio.vue?vue&type=template&id=6828a930&scoped=true&"
import script from "./Claudio.vue?vue&type=script&lang=ts&"
export * from "./Claudio.vue?vue&type=script&lang=ts&"
import style0 from "./Claudio.vue?vue&type=style&index=0&id=6828a930&scoped=true&lang=css&"
import style1 from "./Claudio.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6828a930",
  null
  
)

export default component.exports